import forge from 'node-forge'
import ConvertCerts from '@/utils/ConvertCerts'

export default class {
  _convertCerts = new ConvertCerts()
  _signarure = null
  _publicCertificate = null
  _passwordPrivateKey = null

  constructor(cer, key, password) {
    this._publicCertificate = cer
    this._privateKey = key
    this._passwordPrivateKey = password
  }

  async signature (fileUrl) {
    try {
      const blob = await fetch(fileUrl).then(r => r.blob())
      const data = await blob.arrayBuffer()
      
      const asn1Cert = this._fnAsn1Cert()
      const privateKeyPEM = this._fnGetPrivateKeyDerToPem()

      const p7 = forge.pkcs7.createSignedData()
      p7.content = forge.util.createBuffer(data, 'raw')
      p7.addCertificate(asn1Cert)
      p7.addSigner({
        key: privateKeyPEM,
        certificate: asn1Cert,
        digestAlgorithm: forge.pki.oids.sha256,
        authenticatedAttributes: [{
          type: forge.pki.oids.contentType,
          value: forge.pki.oids.data
        }, {
          type: forge.pki.oids.messageDigest
        }, {
        type: forge.pki.oids.signingTime,
          value: new Date()
        }]
      })

      p7.sign({ detached: true });
      this._signarure = forge.pkcs7.messageToPem(p7)

      return this._signarure
    } catch (error) {
      return null
    }
  }

  _fnAsn1Cert() {
    try{
      let asn1Cert = null
      const derCer = forge.util.decode64(this._publicCertificate)
      if (derCer.indexOf('-----BEGIN CERTIFICATE-----') === 0) {
        asn1Cert = forge.pki.certificateFromPem(derCer)
      } else {
        const asn1Der = forge.asn1.fromDer(derCer)
        asn1Cert = forge.pki.certificateFromAsn1(asn1Der)
      }

      return asn1Cert
    }catch(error){
      return null
    }
  }

  _fnGetPrivateKeyDerToPem() {
    let keyToPem = null

    try {
      const pkcs8PEM = this._convertCerts.pkcs8ToPem(this._privateKey)
      const decryptPrivateKey = forge.pki.decryptRsaPrivateKey(pkcs8PEM, this._passwordPrivateKey)

      keyToPem = forge.pki.privateKeyToPem(decryptPrivateKey)
    } catch (e) {
      if (e.toString().indexOf('Error: Cannot read encrypted private key.') === 0) {
        throw 'No fue posible desencriptar la llave privada.'
      } else {
        throw 'La llave privada está corrupta o la contraseña no es válida.'
      }
    }

    return keyToPem
  }
}